import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message, Icon } from 'antd';
import { graphql, compose } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';
import Dropzone from 'react-dropzone';
import axios from 'axios';

import RetainerClientDocS3PresignedPostMutation from '../graphql/mutations/retainerClientDocS3PresignedPostMutation.graphql';
import CreateRetainerClientDocBizminderMutation from '../graphql/mutations/createRetainerClientDocBizminderMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

class RetainerClientDocumentUpload extends Component {
  state = {
    selectedFile: null,
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, s3PresignedPost, retainerClientId, mutate } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      const { selectedFile } = this.state;
      if (!err && selectedFile) {
        // Get S3 presigned post data
        s3PresignedPost({
          variables: {
            filename: values.filename,
            fileExtension: selectedFile.name.split('.').pop(),
            fileMimeType: selectedFile.type,
          },
        })
          .then(({ data: data1 }) => {
            const { s3PostData } = data1;
            // Upload file to S3
            const formData = new FormData();
            Object.entries(s3PostData.fields).forEach((entry) => {
              formData.append(entry[0], entry[1]);
            });
            formData.append('file', selectedFile);
            axios
              .post(s3PostData.url, formData)
              .then(() => {
                // Create doc entry in DB
                mutate({ variables: { ...values, retainerClientId, s3Key: s3PostData.fields.key } })
                  .then(() => {
                    this.setState({
                      submittingForm: false,
                      selectedFile: null,
                    });
                    form.resetFields();
                    message.success('File Uploaded!');
                  })
                  .catch((err2) => {
                    this.setState({
                      submittingForm: false,
                    });
                    console.log(err2);
                    message.error(err2.message);
                  });
              })
              .catch((axiosErr) => {
                this.setState({
                  submittingForm: false,
                });
                message.error('Could not upload to S3');
                console.log(axiosErr);
              });
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
        if (!selectedFile) message.error('Select file to upload');
      }
    });
  };

  onFileSelection = (files) => {
    this.setState({
      selectedFile: files[0],
    });
  };

  removeSelectedFile = () => {
    this.setState({
      selectedFile: null,
    });
  };

  render() {
    const { submittingForm, selectedFile } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem label="Document Title" hasFeedback>
          {getFieldDecorator('title', {
            rules: [{ required: true, message: 'Field is required!' }],
          })(<TextArea disabled={submittingForm} autosize={{ minRows: 1, maxRows: 2 }} />)}
        </FormItem>
        <FormItem label="Description">
          {getFieldDecorator('description')(
            <TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />,
          )}
        </FormItem>
        <FormItem label="Filename">
          {getFieldDecorator('filename', {
            rules: [
              { required: true, message: 'Field is required!' },
              { pattern: validationRegex.filename, message: 'Only space & allowed characters: . - _' },
            ],
          })(<Input disabled={submittingForm} required />)}
        </FormItem>
        <FormItem label="Select file to upload" required style={{ marginBottom: 0 }} />
        {selectedFile ? (
          <div>
            <p>
              {selectedFile.name}
              <Button style={{ backgroundColor: 'none', border: 'none' }} onClick={this.removeSelectedFile}>
                <Icon type="close-circle" theme="filled" />
              </Button>
            </p>
          </div>
        ) : (
          <Dropzone
            style={{
              width: '100%',
              height: 100,
              textAlign: 'center',
              border: '1px dashed #AAAAAA',
              marginBottom: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            multiple={false}
            onDrop={this.onFileSelection}
          >
            <p style={{ margin: 0, color: '#BBBBBB' }}>
              Drag n Drop file here
              <br />
              OR
              <br />
              Click to select file to upload
            </p>
          </Dropzone>
        )}
        <FormItem>
          <Button type="primary" htmlType="submit" loading={submittingForm}>
            Submit
          </Button>
        </FormItem>
      </Form>
    );
  }
}

RetainerClientDocumentUpload.propTypes = {
  retainerClientId: PropTypes.number.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  s3PresignedPost: PropTypes.func.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default compose(
  graphql(CreateRetainerClientDocBizminderMutation),
  graphql(RetainerClientDocS3PresignedPostMutation, { name: 's3PresignedPost' }),
  Form.create(),
)(RetainerClientDocumentUpload);



// WEBPACK FOOTER //
// ./src/components/RetainerClientDocumentUpload.jsx